import { Box, Text } from "theme-ui";
import React from "react";
import { FlexColumn } from "../..";

const ECSDonationsSection = () => (
  <FlexColumn sx={{ mt: "0px !important" }} gap="2">
    <Box
      sx={{
        fontSize: "12px",
        backgroundColor: "background2",
        padding: "7px",
        margin: "0px !important",
      }}
    >
      Note: Donors need to print the ECS/NACH Mandate Form, sign and courier the
      hard copy to Kanha. The Kanha team would register this mandate form with
      the bankers.
    </Box>
    <Box>
      <Text>ECS Mandate Forms</Text>
      <Box sx={{ fontSize: "13px" }}>
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/01.ECS%20Form-Final.pdf"
            >
              ECS Mandate Form
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/02.Example%20of%20a%20filled%20ECS%20Form.pdf"
            >
              Sample Filled ECS Mandate Form
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/03.Instructions%20for%20filling%20of%20ECS.pdf"
            >
              Instructions to Fill Mandate
            </a>
          </li>
        </ul>
      </Box>
    </Box>
  </FlexColumn>
);

export default React.memo(ECSDonationsSection);
